<script setup>
/* eslint-disable */

    import HeaderMenu from './HeaderMenu.vue';


    document.body.style.backgroundColor = "white";
</script>

<template>

    <HeaderMenu/>

    <div id="home">
        We are....
    </div>

    <div id="footer">

        © 2023 Pocket Dimension Society <br/><br/>
        <span>
            <a href="mailto:pocketdimensionsociety@gmail.com?subject=Hi!">
                Contact
            </a>
        </span>
        
        <span>
            <RouterLink to="/archives">
                Archives
            </RouterLink>
        </span>
            
    </div>


</template>

<style>
#home{
    margin: 0px;
    text-align: center;
    width: 100%;
    margin-top: 80px;
    margin-bottom: 80px;
}


#header-menu{
    text-align: center;
    width: 100%;
    margin-top: 30px;
}

#header-menu .item{
    height: 80px;
    width: 80px;
    margin: auto;
    display: inline-block;
    padding: 0 15px 0 15px;
    vertical-align: top;
    font-weight: bold;
}

#header-menu .item a{
    text-decoration: none;
    color: #a100c2ff;
}

#header-menu .item a:hover{
    text-decoration: underline;
}


.text-logo{
    padding: 0 100px 0 100px;
    margin-bottom: 10px;
    display: inline-block;
}

#footer{
    margin-top: 50px;
    width: 100%;
    text-align: center;
    font-size: small;
}

#footer span{
    padding: 10px;
}

</style>